export const connectorLocalStorageKey = 'connectorId';
